import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";

@connect()
export default class BottomPanelCustomerRecentAppointment extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className="booking_footer" />;
  }
}
